import { render, staticRenderFns } from "./FoldersTopNav.vue?vue&type=template&id=5f06f5f6"
import script from "./FoldersTopNav.vue?vue&type=script&lang=js"
export * from "./FoldersTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports